import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Alert } from 'react-bootstrap';
import Form from "react-validation/build/form";
import APIConfig from "../../../../api/APIConfig";
import swal from 'sweetalert';

import classes from "./styles.module.css"; 

import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
    Select,
    Textarea,
} from '@chakra-ui/react';

function FormProfilMitra() {
    const navigate = useNavigate();

    const [namaResmi, setNamaResmi] = useState('');
    const [namaBrand, setNamaBrand] = useState('');
    const [website, setWebsite] = useState('');
    const [status, setStatus] = useState('');
    const [tahunBerdiri, setTahunBerdiri] = useState('');
    const [kategori, setKategori] = useState('');
    const [sektorBisnis, setSektorBisnis] = useState('');
    const [sizeMitra, setSizeMitra] = useState('');
    const [lokasiPusat, setLokasiPusat] = useState('');
    const [alamat, setAlamat] = useState('');
    const [npwp, setNpwp] = useState('');
    const [nib, setNib] = useState('');

    const [selectedFiles, setSelectedFiles] = useState(undefined);
    const [image, setImage] = useState(undefined);
    const [imageUrl, setImageUrl] = useState(undefined);
    const [srcData, setSrcData] = useState('');
    const [tagline, setTagline] = useState('');
    const [shortdesc, setShortdesc] = useState('');

    const [namabankmitra, setNamabankmitra] = useState('');
    const [namaAkunMitra, setNamaAkunMitra] = useState('');
    const [nomorAkunmitra, setNomorAkunmitra] = useState('');

    
    const getMitraById = async() => {
        const response = await APIConfig.get(`/v1/mitra/${id}`);
        const data = await response.data

        setNamaResmi(data.namaResmi);
        setNamaBrand(data.namaBrand);
        setWebsite(data.website);
        setStatus(data.status);
        setTahunBerdiri(data.tahunBerdiri);
        setKategori(data.kategori);
        setSektorBisnis(data.sektorBisnis);
        setSizeMitra(data.sizeMitra);
        setLokasiPusat(data.lokasiPusat);
        setAlamat(data.alamat);
        setNpwp(data.npwp);
        setNib(data.nib);
        setImage(data.image);
        setTagline(data.tagline);
        setShortdesc(data.shortdesc);
        setNamabankmitra(data.namabankmitra);
        setNamaAkunMitra(data.namaAkunMitra);
        setNomorAkunmitra(data.nomorAkunmitra);
    };

    const updateProfilMitra = async (e) => {
        e.preventDefault();
        
        const data = new FormData();
        data.append("file", image);
        data.append("upload_preset", "magangpro")
        data.append("cloud_name", "dlbioqgfd")

        fetch("https://api.cloudinary.com/v1_1/dlbioqgfd/image/upload",{
            method:"post",
            body: data
        })
        .then(() => {
            setSrcData(data.url)
            console.log("berhasil uploadddd") 
            swal({
                title: "Profil berhasil diubah!",
                icon: "success",
                button: "OK",
            }).then(() => {
                APIConfig.put(`v1/mitra/${id}`, {
                    namaResmi: namaResmi,
                    namaBrand: namaBrand,
                    website: website,
                    status: status,
                    tahunBerdiri: tahunBerdiri,
                    kategori: kategori,
                    sektorBisnis: sektorBisnis,
                    sizeMitra: sizeMitra,
                    lokasiPusat: lokasiPusat,
                    alamat: alamat,
                    npwp: npwp,
                    nib: nib,
                    image: srcData,
                    tagline: tagline,
                    shortdesc: shortdesc,
                    namabankmitra: namabankmitra,
                    namaAkunMitra: namaAkunMitra,
                    nomorAkunmitra: nomorAkunmitra
                }).then(() => {
                    navigate(`/mitra/profile/lihat/${id}`);
                })
            })
        })
        .catch((error) => {
            console.log(error);
            setValidation(error.response.data);
        })
    };

    function selectFiles(event){
        var fileSelected = event.target.files;

        if(fileSelected.length > 0) {
            var fileToLoad = fileSelected[0];
            setSelectedFiles(fileToLoad);
            setImageUrl(URL.createObjectURL(fileToLoad));
                
            var reader = new FileReader();
    
            reader.onload = function(fileLoadedEvent) {
                setSrcData(fileLoadedEvent.target.result)
            }
            reader.readAsDataURL(fileToLoad)
        }
    }

    const [validation, setValidation] = useState({});
    const { id } = useParams();

    useEffect(() => {
        getMitraById();
        
    }, []);
 
    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>

                {
                    validation.errors &&
                        <Alert variant="danger">
                            <ul class="mt-0 mb-0">
                                { validation.errors.map((error, index) => (
                                    <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                )) }
                            </ul>
                        </Alert>
                }

                <Form onSubmit={updateProfilMitra}>
                    <VStack 
                    spacing={4}
                    align='stretch'
                    p={3}
                    >
                        <Heading
                            mb={6}
                            mt={3}
                            color={useColorModeValue('gray.700', 'white')}
                            fontSize={'xl'}
                            fontFamily={'Inter'}>
                            Identitas
                        </Heading>
                        
                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaresmi'>Nama Resmi</FormLabel>
                        <Input
                            isDisabled
                            id='namaresmi'
                            placeholder={namaResmi}
                            />
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='namabrand'>Nama Brand</FormLabel>
                        <Input 
                            isDisabled
                            id='namabrand'
                            placeholder={namaBrand} 
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='tahunBerdiri'>Tahun Berdiri</FormLabel>
                        <Input 
                            id='tahunBerdiri' 
                            placeholder={tahunBerdiri}
                            value={tahunBerdiri}
                            onChange={(e) => setTahunBerdiri(e.target.value)}
                        />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='website'>Website</FormLabel>
                        <Input 
                            id='website' 
                            placeholder={website}
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                        />
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='status'>Status</FormLabel>
                        <Input
                            isDisabled
                            id='status'
                            placeholder={status}
                            />
                        </FormControl>
                    </VStack>

                    <VStack 
                    spacing={4}
                    align='stretch'
                    p={3}
                    mt={6}
                    >
                        <Heading
                            mb={6}
                            mt={3}
                            color={useColorModeValue('gray.700', 'white')}
                            fontSize={'xl'}
                            fontFamily={'Inter'}>
                            Detail Mitra
                        </Heading>
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kategori'>Kategori</FormLabel>
                        <Select 
                            id='kategori'
                            value={kategori}
                            onChange={(e) => setKategori(e.target.value)}>
                            <option disabled selected>Pilih kategori</option>
                            <option value={0}>Startup</option>
                            <option value={1}>Global Company</option>
                            <option value={2}>Multilaterals Organizations</option>
                            <option value={3}>Non-profits Organizations</option>
                            <option value={4}>Hospitals</option>
                        </Select>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='sektorbisnis'>Sektor bisnis</FormLabel>
                        <Select 
                            id='sektorbisnis'
                            value={sektorBisnis}
                            onChange={(e) => setSektorBisnis(e.target.value)}>
                            <option disabled selected>Pilih sektor bisnis</option>
                            <option value={0}>Technology</option>
                            <option value={1}>BUMN</option>
                            <option value={2}>Healthcare and Hospitality</option>
                            <option value={3}>Multilaterals and Non-profits</option>
                            <option value={4}>Professional Services</option>
                            <option value={5}>Others</option>
                        </Select>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='ukuran'>Ukuran Organisasi (Jumlah Karyawan)</FormLabel>
                        <Select id='ukuran'
                            // placeholder='Pilih ukuran organisasi'
                            value={sizeMitra}
                            onChange={(e) => setSizeMitra(e.target.value)}>
                            <option disabled selected>Pilih ukuran organisasi</option>
                            <option value={0}>1-10</option>
                            <option value={1}>11-50</option>
                            <option value={2}>51-100</option>
                            <option value={3}>100-500</option>
                            <option value={4}>501-1000</option>
                            <option value={5}>1001-5000</option>
                            <option value={6}>5001-10000</option>
                            <option value={7}>+10000</option>
                        </Select>

                        </FormControl>
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='lokasipusat'>Lokasi Pusat</FormLabel>
                        <Input 
                            id='lokasipusat' 
                            placeholder='Masukkan lokasi pusat'
                            value={lokasiPusat}
                            onChange={(e) => setLokasiPusat(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='alamat'>Alamat</FormLabel>
                        <Input 
                            id='alamat' 
                            placeholder='Masukkan alamat'
                            value={alamat}
                            onChange={(e) => setAlamat(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='npwp'>NPWP (Nomor Pokok Wajib Pajak)</FormLabel>
                        <Input 
                            id='npwp' 
                            placeholder='Masukkan NPWP (Nomor Pokok Wajib Pajak)'
                            value={npwp}
                            onChange={(e) => setNpwp(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='nib'>NIB (Nomor Induk Berusaha)</FormLabel>
                        <Input 
                            id='lokasipusat' 
                            placeholder='Masukkan NIB (Nomor Induk Berusaha)'
                            value={nib}
                            onChange={(e) => setNib(e.target.value)}/>
                        </FormControl>
                    </VStack>

                    <VStack 
                    spacing={4}
                    align='stretch'
                    p={3}
                    mt={6}
                    >
                        <Heading
                            mb={6}
                            mt={3}
                            color={useColorModeValue('gray.700', 'white')}
                            fontSize={'xl'}
                            fontFamily={'Inter'}>
                            Detail Profil
                        </Heading>
                        {imageUrl===undefined ? (
                            <img style={{width: '20%', height: '20%'}} className="preview" src={image} alt="" />
                        ) : (
                            <img style={{width: '20%', height: '20%'}} className="preview" src={imageUrl} alt="" />
                        )}
                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='logo'>Logo</FormLabel>
                        <input 
                            id='logo' className="custom-file-input" 
                            type='file' accept="image/*" 
                            placeholder="Pilih file"
                            onChange={selectFiles}
                        />
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='tagline'>Tagline</FormLabel>
                        <Input 
                            id='tagline' 
                            placeholder='Masukkan tagline'
                            value={tagline}
                            onChange={(e) => setTagline(e.target.value)}
                        />
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='deskripsi'>Deskripsi Singkat</FormLabel>
                        <Textarea 
                            id='deskripsi' 
                            placeholder='Masukkan Deskripsi Singkat'
                            value={shortdesc}
                            onChange={(e) => setShortdesc(e.target.value)}/>
                        </FormControl>
                    </VStack>
                    
                    <VStack 
                    spacing={4}
                    align='stretch'
                    p={3}
                    mt={6}
                    >
                        <Heading
                            mb={6}
                            mt={3}
                            color={useColorModeValue('gray.700', 'white')}
                            fontSize={'xl'}
                            fontFamily={'Inter'}>
                            Akun Bank
                        </Heading>
                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='namabank'>Nama Bank</FormLabel>
                        <Input 
                            id='namabank' 
                            placeholder='Masukkan Nama Bank'
                            value={namabankmitra}
                            onChange={(e) => setNamabankmitra(e.target.value)}
                        />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaakun'>Nama Akun</FormLabel>
                        <Input 
                            id='namaakun' 
                            placeholder='Masukkan Nama Akun'
                            value={namaAkunMitra}
                            onChange={(e) => setNamaAkunMitra(e.target.value)}
                        />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='nomorakun'>Nomor Akun</FormLabel>
                        <Input 
                            id='nomorakun' 
                            placeholder='Masukkan Nomor Akun'
                            value={nomorAkunmitra}
                            onChange={(e) => setNomorAkunmitra(e.target.value)}
                        />
                        </FormControl>

                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                loadingText='Submitting'
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </VStack>
                </Form>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormProfilMitra;